import { Checkbox, CheckboxField, CheckboxGroup } from "V2.0/common/checkbox";
import { Field, Label, Description } from "V2.0/common/fieldset";

function TagsSection(props) {
  const { tags, onCheckTag, onUncheckTag } = props;

  return (
    <Field>
      <CheckboxGroup className="flex flex-col border rounded-lg py-2 px-4">
        {tags.map((tag, idx) => {
          console.log({ tag });
          return (
            <CheckboxField key={idx}>
              <Checkbox
                name={tag.name}
                checked={tag.isChecked}
                onChange={() => {
                  tag.isChecked ? onUncheckTag(tag.name) : onCheckTag(tag.name);
                }}
              />
              <Label>{tag.name}</Label>
            </CheckboxField>
          );
        })}
      </CheckboxGroup>
    </Field>
  );
}

export default TagsSection;
